import createVueApp from '@/common/create_app'
import sidebar from '@/config/sidebars/organization_settings'

async function initOrgSettingsPage(componentImport, props) {
  const { default: Component } = await componentImport
  createVueApp(Component, { props, sidebar })
}

Styxie.Initializers.Organizations = {
  integrations: (props) => initOrgSettingsPage(
    import('@/vue_widgets/organization_settings/integrations/index.vue'),
    props
  )
}

const usersIndex = (props) => initOrgSettingsPage(import('@/vue_widgets/organization_settings/team_members/index.vue'), props)
const usersForm = (props) => initOrgSettingsPage(import('@/vue_widgets/organization_settings/form/index.vue'), props)

Styxie.Initializers.Users = {
  index: usersIndex,
  new: usersForm,
  edit: usersForm
}

const wlcIndex = (props) => initOrgSettingsPage(import('@/vue_widgets/organization_settings/white_label_configurations/index.vue'), props)
const wlcForm = (props) => initOrgSettingsPage(import('@/vue_widgets/organization_settings/white_label_configurations/form/index.vue'), props)
const wlcTestGmbApi = (props) => initOrgSettingsPage(import('@/vue_widgets/organization_settings/white_label_configurations/test_gmb_api/index.vue'), props)

Styxie.Initializers.WhiteLabelConfigurations = {
  index: wlcIndex,
  new: wlcForm,
  edit: wlcForm,
  test_gmb_api: wlcTestGmbApi
}

Styxie.Initializers.Webhooks = {
  index: (props) => initOrgSettingsPage(
    import('@/vue_widgets/organization_settings/webhooks/index.vue'),
    props
  )
}

Styxie.Initializers.ApiTokens = {
  index: (props) => initOrgSettingsPage(
    import('@/vue_widgets/organization_settings/api_keys/index.vue'),
    props
  )
}
